export const ROOT = {
  HOME: "/",
  LANDING: "/s",
  SIMPLE_PAGE: "/sp",
  STYLEGUIDE: "/styleguide",
  SCREENED: "/not-available",
  DOWNTIME: "/downtime",
};
